"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorBoundary = require("./ErrorBoundary");
Object.keys(_ErrorBoundary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorBoundary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorBoundary[key];
    }
  });
});
var _FooterAppSkeleton = require("./FooterAppSkeleton");
Object.keys(_FooterAppSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FooterAppSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FooterAppSkeleton[key];
    }
  });
});
var _ApiProvider = require("./ApiProvider");
Object.keys(_ApiProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApiProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApiProvider[key];
    }
  });
});
var _FooterContent = require("./FooterContent");
Object.keys(_FooterContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FooterContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FooterContent[key];
    }
  });
});
